import { DOCUMENT, JsonPipe, NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import {
 ChangeDetectionStrategy,
 ChangeDetectorRef,
 Component,
 DestroyRef,
 ElementRef,
 EventEmitter,
 Inject,
 InjectionToken,
 Input,
 OnInit,
 Output,
 PLATFORM_ID,
 TemplateRef,
 ViewChild,
 WritableSignal,
 inject,
 signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { HotelHeader } from '@core/models/domains/hotel';
import { PopUpComponent } from '@shared/components/pop-up/pop-up.component';
import { PdpCommentsPopupComponent } from '../../components/pdp-comments-popup/pdp-comments-popup.component';
import { popupDirective } from '@shared/directives/popup.directive';
import { ActivatedRoute } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationService } from '@shared/components/notification/notification.service';
import { AuthService } from '@core/services/authentication/auth.service';
import { LoginRegisterUiService } from '../../../login-register/login-register-ui.service';
import { CommentsModalComponent } from '../../components/comments-modal/comments-modal.component';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { ModalService } from '@shared/services/modal.service';
import { WebengageService } from '@core/services/webengage.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const WINDOW = new InjectionToken<Window>('Window', {
 factory: () => window,
});

@Component({
 selector: 'iho-pdp-hotel-base-data',
 standalone: true,
 imports: [
  NgIf,
  NgFor,
  MatButtonModule,
  PopUpComponent,
  PdpCommentsPopupComponent,
  popupDirective,
  LoadingComponent,
 ],
 templateUrl: './pdp-hotel-base-data.component.html',
 styleUrls: ['./pdp-hotel-base-data.component.scss'],
 changeDetection: ChangeDetectionStrategy.OnPush,
 providers: [
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
 ],
})
export class PdpHotelBaseDataComponent implements OnInit {
 ngOnInit(): void {
  this.hotelInfoSummary = this.hotelUiService.hotelInfo();
  this.hotelReviewData.set(this.hotelInfoSummary.LabelHotelReview);
 }

 hotelReviewData = signal({});
 hotelInfoSummary: any;
 @Input() type?: number;
 @Input() dataSource?: HotelHeader;
 @Input() isFavorite = false;
 @Output() goToMapEmit: EventEmitter<any> = new EventEmitter();
 hotelUiService = inject(HotelInfoUiService);
 dialog = inject(MatDialog);
 loadingFavorite = false;

 @ViewChild('reviewPopUpRef', { static: true }) reviewPopUpRef!: ElementRef;
 @ViewChild('reviewPopUp', { static: true })
 reviewPopUp!: TemplateRef<PopUpComponent>;
 @ViewChild('likeBtn') likeBtn!: ElementRef;
 onHotelReviewPopUp: WritableSignal<boolean> = signal(false);
 isVisible: boolean = false;
 isTooltip: boolean = true;
 modalService = inject(ModalService);
 destroyRef = inject(DestroyRef);
 // position!: number

 constructor(
  private route: ActivatedRoute,
  private clipboard: Clipboard,
  private notificationService: NotificationService,
  public authService: AuthService,
  public searchBoxService: SearchBoxService,
  private loginRegisterUiService: LoginRegisterUiService,
  private webengageService: WebengageService,
  private pdpUiService: HotelInfoUiService,
  private cdref: ChangeDetectorRef,
  @Inject(DOCUMENT) private document: Document,
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {}

 showReviews() {
  if (isPlatformBrowser(this.platformId)) {
   if (this.window) this.isVisible = true;
  }
 }

 closeReviews() {
  if (this.isTooltip && this.onHotelReviewPopUp()) {
   return;
  }
  this.isVisible = false;
 }

 goToMap() {
  this.goToMapEmit.emit();
 }

 copyToClipboard() {
  this.clipboard.copy(this.document.location.href);
  this.notificationService.success(
   'عملیات موردنظر با موفقیت انجام شد',
   'آدرس صفحه با موفقیت در کلیپ‌بورد اضافه شد'
  );
 }

 addToFavorite() {
  if (this.authService.getUserData()()) {
   if (!this.loadingFavorite) {
    this.loadingFavorite = true;
    // this.isFavorite = !this.isFavorite
    this.hotelUiService
     .addToFavorite()
     .pipe(takeUntilDestroyed(this.destroyRef))
     .subscribe((response: any) => {
      this.loadingFavorite = false;
      this.isFavorite = response.data.isFavorite;
      if (this.isFavorite) {
       this.webengageService.track('add to fav', {
        hotelName: this.hotelInfoSummary?.HotelHeader?.FullName,
        hotelType: this.hotelInfoSummary?.HotelHeader?.TypeName,
        Price: this.pdpUiService.roomApiResponse$.value.room.briefPrice.ihoPrice,
        hotelGrade: this.hotelInfoSummary?.HotelHeader?.Star?.GradeId,
        destination: this.hotelInfoSummary?.HotelHeader?.FullName,
       });

       this.notificationService.success(
        'اضافه به علاقه مندی ها',
        'هتل به لیست علاقه مندی های شما اضافه شد'
       );
      } else {
       this.webengageService.track('rem from fav', {
        hotelName: this.hotelInfoSummary?.HotelHeader?.FullName,
        hotelType: this.hotelInfoSummary?.HotelHeader?.TypeName,
        Price: this.pdpUiService.roomApiResponse$.value.room.briefPrice.ihoPrice,
        hotelGrade: this.hotelInfoSummary?.HotelHeader?.Star?.GradeId,
        destination: this.hotelInfoSummary?.HotelHeader?.FullName,
       });
       this.notificationService.success(
        'حذف از علاقه مندی ها',
        'هتل از لیست علاقه مندی های شما حذف شد'
       );
      }
      this.cdref.detectChanges();
     });
   }
  } else {
   this.loginRegisterUiService.showMyModal();
  }
 }
 showComments(e: Event) {
  e.stopPropagation();
  if (this.dataSource?.Score.Total == 0) return;

  const dialogRef = this.dialog.open(CommentsModalComponent, {
   panelClass: [
    'custom-modal',
    'comments-modal',
    'w-screen',
    'lg:w-[81%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[88vh]',
    'lg:min-h-[700px]',
   ],
   data: {
    dataSource: this.hotelReviewData(),
    HotelHeader: this.hotelInfoSummary.HotelHeader,
    hid: this.hotelInfoSummary.HotelId,
    type: this.hotelInfoSummary.Type,
    HouseId: this.hotelInfoSummary.HouseId,
   },
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {
    this.modalService.isAnyModalOpen.set(false);
   });

  dialogRef
   .afterOpened()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe(() => {
    this.modalService.isAnyModalOpen.set(true);
   });
 }
}
